
define('text!templates/parts/menu/menu-dropdown-item.html',[],function () { return '{{^empty}}<span class="{{icon}}"></span>{{#t}}{{label}}{{/t}}{{/empty}}\n';});

